import { MESSAGE_TYPE } from "@home-health-notify/domain";
import AcknowledgeBubble from "../message/messageType/AcknowledgeBubble";
import InfoBubble from "../message/messageType/InfoBubble";
import PriorityBubble from "../message/messageType/PriorityBubble";
import NormalBubble from "../message/messageType/NormalBubble";
import React from "react";
import DeleteBubble from "../message/messageType/DeletedBubble";
import { ReplyBubble } from "../message/messageType/ReplyBubble";

export type IMessageTypeComponentMap = {
  [key in MESSAGE_TYPE]: React.ElementType;
};

export function getMessageTypeComponent(
  messageType: MESSAGE_TYPE,
  showDeletedBubble: boolean,
): React.ElementType {
  if (showDeletedBubble) {
    return DeleteBubble;
  }
  const MessageTypeComponentMap: IMessageTypeComponentMap = {
    [MESSAGE_TYPE.ACKNOWLEDGE]: AcknowledgeBubble,
    [MESSAGE_TYPE.ACKNOWLEDGED]: AcknowledgeBubble,
    [MESSAGE_TYPE.INFO]: InfoBubble,
    [MESSAGE_TYPE.PRIORITY]: PriorityBubble,
    [MESSAGE_TYPE.REMINDER]: NormalBubble,
    [MESSAGE_TYPE.NORMAL]: NormalBubble,
    [MESSAGE_TYPE.REPLY]: ReplyBubble,
    [MESSAGE_TYPE.SUGGESTED_USERS_TO_ADD]: NormalBubble,
  };
  return (
    MessageTypeComponentMap[
      messageType as keyof typeof MessageTypeComponentMap
    ] || NormalBubble
  );
}

export function isBlobImage(url: string) {
  return url?.startsWith("blob");
}
